import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import uniqueId from 'lodash/uniqueId';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Cross, Warning, Tick } from '../../helpers/icon-dictionary';
import css from './index.scss';
import Button from '../../components/button/index';
import messages from './messages';
import Modal from '../../components/modal/index';
import StudentUnassign from '../../components/student-unassign/index';
import ConfirmationMessage from '../../components/confirmation-message/index';
import ClassCourses from '../class-courses';

const StudentClassList = ({
    assignedClassrooms,
    handleOnStudentUnassign,
    unassignStudentsSuccessConfirmation,
    isUnassignedModalOpen,
    showUnassignStudentModal,
    handleOnCloseModal,
    handleOnUnassignConfirm,
    isLoading,
    intl }) => {
    const confirmation = isUnassignedModalOpen
        ? (
            <StudentUnassign
                handleOnCancel={handleOnCloseModal}
                handleOnOk={handleOnUnassignConfirm}
                icon={Warning}
                isLoading={isLoading}
                title={intl.formatMessage(messages.unassignStudent)}>
                <div>{intl.formatMessage(messages.selectedStudentWillBe)}
                    <span className={css.highlight}>{` ${intl.formatMessage(messages.unassignedClassList)} `}</span>
                    {intl.formatMessage(messages.mayLoseAccessToProducts)}</div>
            </StudentUnassign>)
        : (
            <ConfirmationMessage
                handleOnCloseModal={unassignStudentsSuccessConfirmation}
                icon={Tick}
                title={intl.formatMessage(messages.studentsUnassigned)} />);

    return (<div>
        <div className={css.header}>
            <div className={css.columns}>{intl.formatMessage(messages.class)}</div>
            <div className={css.columns}>{intl.formatMessage(messages.group)}</div>
            <div className={css.columns}>{intl.formatMessage(messages.course)}</div>
            <div className={css.columns}>{intl.formatMessage(messages.teacher)}</div>
            <div className={css.columns}>{intl.formatMessage(messages.year)}</div>
        </div>
        {
            map(assignedClassrooms, classInfo => (
                <div className={css.list} key={classInfo.classId}>
                    <div className={css.columns}>{classInfo.name}</div>
                    <div className={css.columns}>{classInfo.groupName}</div>
                    <div className={css.columns}>{ClassCourses({
                        courseTitle: classInfo.courseName,
                        conquestCourseTitle: classInfo.conquestCourseName,
                        upfCourseTitle: classInfo.upfCourseName,
                        yearGroup: classInfo.yearGroup,
                        intl,
                        isOptedOut: classInfo.isOptedOut })}</div>
                    <div className={css.columns}>
                        {
                            map(classInfo.teachersName, teacher => (
                                <div key={uniqueId('Student_Class_List_Teacher_')}>{teacher}</div>
                            ))
                        }
                    </div>
                    <div className={css.columns}>{classInfo.yearGroup}</div>
                    <Button
                        containerClassName={css.unassignClass}
                        handleOnClick={() => handleOnStudentUnassign(classInfo.classId)}
                        icon={Cross}
                        iconClassName={css.icon} />
                </div>
            ))
        }
        <Modal show={showUnassignStudentModal}>
            { confirmation }
        </Modal>
    </div>);
};

StudentClassList.propTypes = {
    assignedClassrooms: PropTypes.array,
    handleOnStudentUnassign: PropTypes.func,
    showUnassignStudentModal: PropTypes.bool,
    unassignStudentsSuccessConfirmation: PropTypes.func,
    isUnassignedModalOpen: PropTypes.bool,
    handleOnUnassignConfirm: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    isLoading: PropTypes.bool,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(StudentClassList));



// WEBPACK FOOTER //
// ./app/components/student-class-list/index.js